<header *ngIf="currentUserLogged">
  <nav class="navbar navbar-expand-sm navbar-toggleable-sm navbar-light bg-white border-bottom box-shadow mb-3">
    <div class="container container-header">

      <a class="fgl-logo" [routerLink]="['/']">
        <img style="height: 30px;" src="/Frigelar-Brand.png" class="imgCustomer img-responsive center-block col-padding-left col-padding-right" alt="Frigelar">
      </a>
      <button class="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target=".navbar-collapse"
              aria-label="Toggle navigation"
              [attr.aria-expanded]="isExpanded"
              (click)="toggle()">
        <span class="navbar-toggler-icon"></span>
      </button>
      <!--<div class="navbar-menu navbar-collapse collapse d-sm-inline-flex flex-sm-row-reverse" id="navMenuOptions" [ngClass]="{ show: isExpanded }" *ngIf="currentUserLogged">
        <ul class="navbar-nav flex-grow">
          <li class="nav-item" [routerLinkActive]="['link-active']" *ngIf="currentUserLogged.userPermission.home">
            <a class="nav-link text-dark" [routerLink]="['/']">Página inicial</a>
          </li>

          <li class="nav-item" [routerLinkActive]="['link-active']" *ngIf="currentUserLogged.userPermission.order">
            <a class="nav-link text-dark" [routerLink]="['/order-tracking']">Pedidos</a>
          </li>

          <li class="nav-item" [routerLinkActive]="['link-active']" *ngIf="currentUserLogged.userPermission.payment">
            <a class="nav-link text-dark" [routerLink]="['/credit-card-payment']">Pagamentos</a>
          </li>

          <li class="nav-item" [routerLinkActive]="['link-active']" *ngIf="currentUserLogged.userPermission.orderService">
            <a class="nav-link text-dark" [routerLink]="['/order-service']">Serviços</a>
          </li>
        </ul>
      </div>-->
      <div class="navbar-menu-user">
        <div>
          <img src="../../assets/User.svg" class="navbar-menu-user-icone" />
          <div class="navbar-menu-user-text navbar-menu-user-bold">Olá {{currentUserLogged.firstName}} {{currentUserLogged.lastName}}</div>
          <div class="navbar-menu-user-text">{{currentUserLogged.userPermission.permissionName}}</div>
        </div>
        <a class="nav-link text-dark navbar-menu-user-sair" (click)="logout()">Sair</a>
      </div>
    </div>
  </nav>
</header>

